import { getFrontendConfigLoader } from '@doxyme/config';
import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { businessServicesConfig } from './businessServicesConfig';

export const ogBaseQuery: typeof fetchBaseQuery = (options, ...rest) => {
  return fetchBaseQuery(
    {
      ...options,
      baseUrl: getFrontendConfigLoader().get('API_URL') as string,
      prepareHeaders: (headers) => {
        const token = businessServicesConfig.getConfiguration().getToken();
        if (token !== undefined) {
          headers.append('authorization', token);
        }
        return headers;
      },
    },
    ...rest,
  );
};
